var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M65.152 19.246V6.569h3.885l.295 1.622c1.081-1.203 2.557-1.77 4.597-1.77 3.884 0 6.072 2.31 6.072 6.412v6.413h-4.253v-6.044c0-2.235-1.008-3.39-3-3.39-2.138 0-3.342 1.13-3.342 3.144v6.289h-4.254M58.86 19.246V6.569h4.429v12.677zm2.202-13.807c-1.302 0-2.31-.933-2.31-2.186s1.006-2.187 2.31-2.187 2.31.934 2.31 2.187-1.007 2.186-2.31 2.186M43.283 19.246V1h13.669v3.833h-9.145v3.095h7.72v3.587h-7.72v7.73zM33.459 19.238c-4.819 0-8.04-2.58-8.04-6.485s3.221-6.485 8.04-6.485 8.015 2.603 8.015 6.485c0 3.881-3.22 6.485-8.015 6.485m0-3.39c2.286 0 3.688-1.179 3.688-3.095s-1.401-3.096-3.688-3.096-3.712 1.18-3.712 3.096 1.401 3.095 3.712 3.095M19.219 19.28V1.026h4.366v18.251H19.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "m15.384 2.943-3.845 2.893-4.705 3.452v3.763l9.612-7.153.002-.041q0-1.771-1.064-2.912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.721 11.987q-.483-.886-1.465-1.422a5 5 0 0 0-.745-.323l-2.84 2.121.004.004q.64.484.641 1.395c0 .608-.209 1.096-.628 1.409q-.627.47-1.882.47H4.464V4.655h5.053q.994 0 1.556.483.329.284.464.697l3.845-2.892a4.5 4.5 0 0 0-.804-.677q-1.87-1.238-5.452-1.239H0v18.269h9.047q3.974 0 6.067-1.33 2.091-1.332 2.091-3.863 0-1.226-.484-2.114z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h80v20H0z"
  })))));
};
export default SvgLogo;